import type { RepAdvanceMode } from './tempoConstants'

/** Mouse/trackpad devices use manual confirm; touch-first devices use metronome auto-advance. */
export function defaultRepAdvanceMode(): RepAdvanceMode {
  if (typeof window === 'undefined') return 'manual'
  return window.matchMedia('(pointer: fine)').matches ? 'manual' : 'auto'
}
